export default "__VITE_ASSET__BWaf_0Qq__"